module.exports = __webpack_public_path__ + "img/tab_img3.9cc819c1.jpg";